/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

/* components */
import UserForm from "./UserForm";
import Page from "../../shared/Page";

class UserFormWrapper extends Component {
	constructor(props) {
		super(props);
		this.indefiniteArticle = "A";
		this.label = "User";
		this.params = props.match.params;
		this.appKey = this.params.appKey ? this.params.appKey : 0;
		this.userId = this.params.id ? this.params.id : 0;
	}

	componentDidMount() {
		const { selectUser, type } = this.props;
		if (type === "update" || type === "copy") {
			selectUser(this.userId);
		}
	}

	submitForm(values, submitHandler, id = "") {
		const { createItem, copyItem, updateItem, type } = this.props;
		switch (type) {
			case "new":
				createItem(values, submitHandler);
				break;
			case "copy":
				copyItem(values, submitHandler);
				break;
			case "update":
				updateItem(values, submitHandler, id);
				break;
			default:
				break;
		}
	}

	renderCreateForm = () => {
		const { experiences, currentUser } = this.props;
		return (
			<div className="ta-center">
				<h3 className="page-title">
					Create {this.indefiniteArticle} {this.label}
				</h3>
				<UserForm
					user={currentUser}
					experiences={experiences}
					onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler)}
					buttonLabel={`Create ${this.label}`}
				/>
			</div>
		);
	};

	renderFormWithUser = action => {
		const { experiences, currentUser, selectedUser } = this.props;
		const apps = selectedUser && selectedUser.apps;
		const selectedApp = apps && apps.find(app => app.key === this.appKey);
		const selectedRole = selectedApp && selectedApp.role;
		const selectedExperiences = selectedApp && selectedApp.experiences;
		const experienceIds = selectedExperiences && selectedExperiences.map(experience => experience.id);
		const initialValues = selectedExperiences && {
			...selectedUser,
			role: selectedRole,
			experienceIds: experienceIds,
		};

		return (
			<div className="ta-center">
				<h3 className="page-title">
					{action} {this.indefiniteArticle} {this.label}
				</h3>
				{selectedUser && selectedUser.id === this.userId ? (
					<UserForm
						user={currentUser}
						experiences={experiences}
						onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler, selectedUser.id)}
						initialValues={initialValues}
						buttonLabel={`${action} ${this.label}`}
						actionType={action === "Update" ? "update" : ""}
						id={selectedUser.id}
					/>
				) : (
					"Loading..."
				)}
			</div>
		);
	};

	renderCopyForm = () => this.renderFormWithUser("Copy");

	renderUpdateForm = () => this.renderFormWithUser("Update");

	render() {
		let content = "";
		switch (this.props.type) {
			case "new":
				content = this.renderCreateForm();
				break;
			case "copy":
				content = this.renderCopyForm();
				break;
			case "update":
				content = this.renderUpdateForm();
				break;
			default:
				content = "loading";
				break;
		}
		return <Page title="My Posts">{content}</Page>;
	}
}

UserFormWrapper.propTypes = {
	type: PropTypes.string,
	items: PropTypes.array,
	createItem: PropTypes.func,
	copyItem: PropTypes.func,
	updateItem: PropTypes.func,
	match: PropTypes.object,
	experiences: PropTypes.object,
	currentUser: PropTypes.object,
	appsActions: PropTypes.object,
	selectedUser: PropTypes.object,
	selectUser: PropTypes.object,
};

export default withRouter(UserFormWrapper);
